import React from 'react';
import { Link } from 'react-router-dom';
import './mentions-messages.scss';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import Tabs from '../../tabs/custom-tab';
import getInitials from '../../../helpers/utils';
import UserImage from '../../user-image/user-image';

function MentionsMessages({ data, t, closeNotification }) {
  const hostUrl = `${window.location.protocol}//${window.location.host}`;
  return (
    <div className="mentions-messages-container">
      <Tabs className="notification-tab" disableURL>
        <div
          value="Chat"
          label={t('notifications.chat')}
          className="notification-tab"
        >
          <ul className="notification-list">
            {data?.map((ntf) => {
              const cleanText = ntf?.text
                ?.replaceAll('<mention', '<span  class="id disable-pointer"')
                ?.replaceAll('</mention>', '</span>');
              return (
                <li class="unread">
                  <div className="notification-item">
                    <span className="time">{ntf?.diff}</span>
                    <div className="user-image">
                      <UserImage
                        path={ntf?.senderOrgDetails?.senderOrgLogo}
                        shortName={getInitials(
                          ntf?.senderOrgDetails?.senderOrgName
                        )}
                        size="medium"
                      />
                    </div>
                    <div className="details">
                      <p>
                        <span className="name">
                          {ntf?.senderOrgDetails?.senderOrgName}
                        </span>{' '}
                        <span className="notification-devider-line">|</span>{' '}
                        <span className="name">
                          {t(`notifications.${ntf?.type}`)}{' '}
                          {ntf?.link ? (
                            <Link
                              to={`${hostUrl}/${ntf.link}?notificationId=${
                                ntf?.notificationId || ntf?._id
                              }&activeTab=Details`}
                              className="link"
                              onClick={closeNotification}
                            >
                              #{ntf?.relationNo}
                            </Link>
                          ) : (
                            <>#{ntf?.relationNo}</>
                          )}
                        </span>
                      </p>
                      <p>
                        <span className="name mr-5">
                          {ntf?.senderDetails?.firstName}{' '}
                          {ntf?.senderDetails?.lastName}
                        </span>
                        {ntf?.text !== '' && (
                          <span className="message">
                            {ReactHtmlParser(cleanText)}
                          </span>
                        )}
                      </p>
                    </div>
                    {ntf?.count > 1 && (
                      <div className="action align-center">
                        <span className="counter">+{ntf.count - 1}</span>
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div label="Mentions" value="Mentions" className="notification-tab">
          <ul className="notification-list">
            {data?.map((ntf) => {
              const cleanText = ntf?.text
                ?.replaceAll('<mention', '<span  class="id disable-pointer"')
                ?.replaceAll('</mention>', '</span>');

              if (!ntf.mentioned) return null;
              return (
                <li>
                  <div className="notification-item">
                    <span className="time">{ntf?.diff}</span>
                    <div className="user-image">
                      <UserImage
                        path={ntf?.senderOrgDetails?.senderOrgLogo}
                        shortName={getInitials(
                          ntf?.senderOrgDetails?.senderOrgName
                        )}
                        size="medium"
                      />{' '}
                    </div>
                    <div className="details no-action">
                      <p>
                        <span className="name">
                          {' '}
                          {ntf?.senderOrgDetails?.senderOrgName}
                        </span>
                      </p>
                      <p>
                        {t(`notifications.${ntf?.type}`)}{' '}
                        {ntf?.link ? (
                          <Link
                            to={`${hostUrl}/${ntf.link}?notificationId=${
                              ntf?.notificationId || ntf?._id
                            }&activeTab=Details`}
                            className="link"
                            onClick={closeNotification}
                          >
                            #{ntf?.relationNo}
                          </Link>
                        ) : (
                          <>#{ntf?.relationNo}</>
                        )}
                        ,{' '}
                        <span className="id mr-5">
                          {`@${ntf?.senderDetails?.firstName}
                          ${ntf?.senderDetails?.lastName}`}
                        </span>{' '}
                        {t('notifications.mentiontext')}{' '}
                        {ntf?.text !== '' && (
                          <span className="name">
                            {ReactHtmlParser(cleanText)}
                            {/*     <span className="id">@Jorge_Dan</span> */}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </Tabs>
      {/* <Tabs className="notification-tab" disableURL></Tabs> */}
    </div>
  );
}

MentionsMessages.propTypes = {
  data: PropTypes.instanceOf(Array),
  t: PropTypes.func,
  closeNotification: PropTypes.func,
};

MentionsMessages.defaultProps = {
  data: [],
  t: () => {},
  closeNotification: () => {},
};

export default MentionsMessages;
